import api from "../utils/api";
import {
    PERMISSIONS_LOADED
} from "./types";

export const mine = () => async (dispatch) => {
    try {
        const res = await api.get(`/permissions/me`);
        dispatch({
            type: PERMISSIONS_LOADED,
            payload: res.data
        });
        return res.data;
    } catch (err) {
        console.error("Unable to load license permissions.", {
            status: err?.response?.status,
            data: err?.response?.data,
            url: err?.config?.url,
        });
        dispatch({
            type: PERMISSIONS_LOADED,
            payload: []
        });
    }
}
